import { handleActions } from 'redux-actions'

export const defaultState = {
  ordersModal: null,
}

const reducer = handleActions(
  {
    'ORDER/SET_CURRENT_MODAL': (state, action) => {
      const { payload } = action

      return {
        ...state,
        ordersModal: payload,
      }
    },
  },
  defaultState,
)

export default reducer
